import { createContext, useState, useEffect } from "react";
import axios from "axios";
import SummaryApi from "../common";
import { authHeader } from "../helpers/auth-header";
import { useSelector } from "react-redux";

export const GlobalContext = createContext();

const GlobalProvider = ({ children }) => {
  const [cartProductCount, setCartProductCount] = useState(0);

  const { user: isLoggedIn } = useSelector((state) => state?.user);

  const fetchUserAddToCart = async () => {
    try {
      const { data } = await axios.get(SummaryApi.addToCartProductCount.url, {
        headers: authHeader(),
      });
      setCartProductCount(data.listcarts.count);
    } catch (error) {
      console.error("Error fetching cart count:", error);
    }
  };

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     setTimeout(() => {
  //       fetchUserAddToCart();
  //     });
  //   }
  // }, [isLoggedIn]);

  return (
    <GlobalContext.Provider
      value={{
        cartProductCount,
        fetchUserAddToCart,
        setCartProductCount,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;
